import script from "./AppManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManage.vue?vue&type=script&setup=true&lang=js"

import "./AppManage.vue?vue&type=style&index=0&id=85e5eefa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e5eefa"]])

export default __exports__